import { HStack } from "@/components/Layout";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { CERTIFICATION_TYPE_STEPS } from "../-constants/steps";
import useCertificationTypeParam from "../-hooks/useCertificationType";
import { getCertificationFormStoreContext } from "../-store/certificationFormStoreContext";
import InnerNavigation from "./-components/InnerNavigation";
import ManualForm from "./-components/ManualForm";
import { ProgressCard } from "./-components/ProgressCard";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute(
  "/_staff/certifications/add/$certificationType/",
)({
  validateSearch: zodValidator(SearchSchema),
  component: () => <Form />,
});

function Form() {
  const { certificationType } = useCertificationTypeParam();
  const { context } = getCertificationFormStoreContext(certificationType);
  const store = context.createStore();
  const steps = CERTIFICATION_TYPE_STEPS[certificationType];

  return (
    <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="flex-shrink-0">
          <InnerNavigation steps={steps} />
        </div>
        <ManualForm className="flex-grow min-w-[340px]" steps={steps} />
        <div className="flex-shrink-0">
          <ProgressCard steps={steps} />
        </div>
      </HStack>
    </context.Provider>
  );
}
